<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="SPU ID">
                  <el-input v-model="inputSpuId" clearable>
                    <el-button slot="append" @click="showBatchForm">批量</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="货号">
                  <el-input v-model="queryForm.designerId" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="颜色">
                  <el-input v-model="queryForm.colorCode" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="商品名称">
                  <el-input v-model="queryForm.spuName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="季节">
                  <el-select v-model="queryForm.seasonCodes" multiple collapse-tags clearable>
                    <el-option v-for="item in seasonList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="品牌">
                  <el-select v-model="queryForm.brandIds" multiple collapse-tags filterable clearable>
                    <el-option v-for="item in brandList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="上架状态">
                  <el-select v-model="queryForm.statusList" multiple collapse-tags clearable>
                    <el-option label="已上架" :value="1"></el-option>
                    <el-option label="已下架" :value="2"></el-option>
                    <el-option label="售罄" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="制作类型">
                  <el-select v-model="queryForm.spuEditType" clearable>
                    <el-option label="一次编辑" :value="1"></el-option>
                    <el-option label="二次编辑" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="是否禁售">
                  <el-select v-model="queryForm.banSale" clearable>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手店">
                  <el-select v-model="queryForm.vendorIds" multiple filterable collapse-tags clearable>
                    <el-option v-for="item in vendorList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="SPU创建时间">
                  <el-date-picker
                    style="width: 100%"
                    v-model="daterange"
                    type="daterange"
                    :clearable="true"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="类目">
                  <el-cascader
                    v-model="queryForm.categoryIds"
                    collapse-tags
                    :options="categoryList"
                    :props="optionProps"
                    :style="{width: '100%'}"
                    clearable
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div>
      <el-button type="primary" @click="joinSelection">加入</el-button>
      <el-button type="primary" @click="quitSelection">退出</el-button>
      <el-button type="primary" @click="joinByParmas" :loading="joinLoading">按查询条件全部加入</el-button>
      <el-button type="primary" @click="quitByParmas" :loading="quitLoading">按查询条件全部退出</el-button>
    </div>
    <el-table ref="table" :data="tableData" @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="" width="50" class-name="nopadding">
        <template slot-scope="scope">
          <list-img :img="scope.row.coverImg" :width="30"></list-img>
        </template>
      </el-table-column>
      <el-table-column prop="spuId" label="SPU ID">
        <template slot-scope="scope">
          <el-link type="primary" :href="`/#/platGoods/spuInfo/${scope.row.spuId}`" target="_blank">{{ scope.row.spuId }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="designerId" label="货号"></el-table-column>
      <el-table-column prop="colorCode" label="颜色"></el-table-column>
      <el-table-column prop="spuName" label="商品名称"></el-table-column>
      <el-table-column prop="seasonCode" label="季节"></el-table-column>
      <el-table-column prop="categoryName" label="类目"></el-table-column>
      <el-table-column prop="brandName" label="品牌"></el-table-column>
      <el-table-column label="上架状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1">已上架</span>
          <span v-if="scope.row.status === 2">已下架</span>
          <span v-if="scope.row.status === 3">售罄</span>
        </template>
      </el-table-column>
      <el-table-column label="制作类型">
        <template slot-scope="scope">
          <span v-if="scope.row.spuEditType === 1">一次编辑</span>
          <span v-if="scope.row.spuEditType === 2">二次编辑</span>
        </template>
      </el-table-column>
      <el-table-column label="商品池状态">
        <template slot-scope="scope">
          <span v-if="scope.row.topSpuStatus === 1">未加入</span>
          <span v-if="scope.row.topSpuStatus === 2">已加入</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="批量SPU查询" :visible.sync="dialogVisible" width="400px">
      <p class="mb10">请输入SPU ID（一行一个，最多1000个）：</p>
      <el-input
        type="textarea"
        :rows="14"
        placeholder="请输入内容"
        v-model="inputStr">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="加入" :visible.sync="dialogVisible2" :close-on-click-modal="false" width="800px">
      <div class="mb10">
        商品类型：
        <el-radio-group v-model="isBooking">
          <el-radio :label="false">现货</el-radio>
          <el-radio :label="true">预定</el-radio>
        </el-radio-group>
      </div>
      <div class="mb20" v-if="isBooking">
        预定天数：
        <el-input v-model="bookingStartDays" @change="changeBookingDays" @input="(val) => inputNum(val, 'bookingStartDays')" style="width: 100px"></el-input>
        ~
        <el-input v-model="bookingEndDays" @change="changeBookingDays" @input="(val) => inputNum(val, 'bookingEndDays')" style="width: 100px"></el-input>
      </div>

      <el-button type="primary" size="small" @click="onClickSelectAll">选择所有店铺</el-button>
      <el-button type="primary" size="small" @click="onClickClear">取消全部</el-button>
      <el-checkbox-group class="mt10" v-model="joinVendorList">
        <el-checkbox v-for="item in toJoinVendorList" :key="item.vendorId" :label="item.vendorId">{{ item.vendorName }}</el-checkbox>
      </el-checkbox-group>
      <p class="mt10" v-if="toJoinVendorList.length === 0">无店铺可选择</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCounterSpuList,
  delCounterSpuByIds,
  delCounterSpuByParam,
  addCounterSpuBySpuIds,
  confirmAddCounterSpuBySpuIds,
  confirmAddCounterSpuByParam,
  getVendorListByBrandId,
  checkBrand,
} from "../../api/merchants";
import {
  getCategory,
} from '../../api/mapping';
import {
  getSeasonList,
  getBrandList,
  getVendorList,
} from '../seller/api';
import ListImg from '../shared/ListImg.vue';

export default {
  components: {
    ListImg,
  },
  data() {
    return {
      fullscreenLoading: false,
      joinLoading: false,
      quitLoading: false,
      brandList: [],
      categoryList: [],
      vendorList: [],
      seasonList: [],
      daterange: [],
      inputSpuId: '',
      queryForm: {
        designerId: null,
        colorCode: null,
        spuName: null,
        seasonCodes: [],
        categoryIds: [],
        brandIds: [],
        statusList: [],
        spuEditType: null,
        banSale: null,
        vendorIds: [],
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      inputStr: '',
      optionProps: {
        expandTrigger: "hover",
        emitPath: false,
        checkStrictly: false,
        multiple: true,
      },
      dialogVisible2: false,
      joinVendorList: [],
      toJoinVendorList: [],
      multipleSelection: [],
      isBooking: false,
      bookingStartDays: null,
      bookingEndDays: null,
    };
  },
  created() {
    getBrandList().then(res => {
      this.brandList = (res.data || []).map(item => ({
        label: item.englishName,
        value: item.brandId
      }));
    });
    getCategory().then(res => {
      if (res.data && res.data.data) {
        this.categoryList = Object.freeze(this.gatherCategory(res.data.data))
      }
    })
    getSeasonList().then(res => {
      this.seasonList = (res.data || []).map(item=>{
        return {
          label: item.seasonCode,
          value: item.seasonCode
        }
      })
    })
    getVendorList(null).then(res => {
      this.vendorList = (res.data || []).map(item => {
        return {
          value: item.vendorId,
          label: item.vendorName
        }
      })
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.spuId = null;
      this.queryForm.designerId = null;
      this.queryForm.colorCode = null;
      this.queryForm.spuName = null;
      this.queryForm.seasonCodes = [];
      this.queryForm.categoryIds = [];
      this.queryForm.brandIds = [];
      this.queryForm.statusList = [];
      this.queryForm.banSale = null;
      this.queryForm.spuId = null;
      this.queryForm.vendorIds = [];
      this.daterange = [];
      this.inputSpuId = '';
      this.queryForm.pageNo = 1;
      this.getTableData();
      this.$refs.table.clearSelection();
    },
    getQueryParams() {
      let spuIds = [];
      if (this.inputSpuId) {
        if (this.inputSpuId.indexOf(',')) {
          spuIds = this.inputSpuId.split(',');
        } else {
          spuIds = [this.inputSpuId];
        }
      }
      return {
        ...this.queryForm,
        spuIds,
        startCreatedAt: this.daterange && this.daterange[0] || null,
        endCreatedAt: this.daterange && this.daterange[1] || null,
      };
    },
    getTableData() {
      this.loading = true;
      getCounterSpuList(this.getQueryParams()).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list || [];
        }
        this.loading = false;
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    gatherCategory(items) {
      if (Array.isArray(items)) {
        return items.map(item => {
          let newItem = {
            label: item.chineseName,
            value: item.categoryId
          };
          if (Array.isArray(item.children)) {
            newItem.children = this.gatherCategory(item.children);
          }
          return newItem;
        });
      } else {
        return items;
      }
    },
    showBatchForm() {
      if (this.inputSpuId) {
        this.inputStr = this.inputSpuId.split(',').join('\n');
      }
      this.dialogVisible = true;
    },
    submit() {
      this.inputSpuId = this.inputStr.split('\n').filter(item => item).join(',');
      this.dialogVisible = false;
    },
    joinSelection() {
      if (this.multipleSelection.length == 0) {
        this.$message('请选择要操作的商品');
        return;
      }
      if (!this.multipleSelection.some(item => item.topSpuStatus === 1)) {
        this.$message('选择的商品均是已加入，无法执行加入操作');
        return;
      }
      const set = new Set();
      this.multipleSelection.forEach(item => {
        set.add(item.brandId);
      })
      if (set.size > 1) {
        this.$message('无法批量加入多个品牌的spu，请分品牌选择加入');
        return;
      }
      getVendorListByBrandId({
        brandId: this.multipleSelection[0].brandId,
      }).then(res => {
        if (res.data && res.data.data) {
          this.toJoinVendorList = res.data.data;
          this.joinVendorList = res.data.data.map(item => item.vendorId);
        } else {
          this.toJoinVendorList = [];
          this.joinVendorList = [];
        }
      });
      this.isJoinByParmas = false;
      this.isBooking = false;
      this.bookingStartDays = null;
      this.bookingEndDays = null;
      this.dialogVisible2 = true;
    },
    quitSelection() {
      if (this.multipleSelection.length == 0) {
        this.$message('请选择要操作的商品');
        return;
      }
      if (!this.multipleSelection.some(item => item.topSpuStatus === 2)) {
        this.$message('选择的商品均是未加入，无法执行退出操作');
        return;
      }
      this.$confirm('确认退出选中的所有商品？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCounterSpuByIds({
          spuIds: this.multipleSelection.map(item => item.spuId).join(','),
        }).then((res) => {
          if (res.data && res.data.success) {
            this.$message.success('批量退出任务已提交，请在任务管理中查看任务完成情况');
            this.getTableData();
          } else {
            this.$message.warning(res.data.message || '系统异常');
          }
        })
      }).catch(() => {});
    },
    async joinByParmas() {
      if (this.inputSpuId) {
        if (this.queryForm.brandIds.length > 1) {
          this.$message('品牌只能选1个');
          return;
        }
      } else {
        if (this.queryForm.brandIds.length !== 1) {
          this.$message('请选择单个品牌');
          return;
        }
      }
      this.joinLoading = true;
      const res = await checkBrand(this.getQueryParams());
      if (res.data && res.data.success) {
        this.joinByParmasBrandId = res.data.data;
        getVendorListByBrandId({
          brandId: res.data.data,
        }).then(res => {
          if (res.data && res.data.data) {
            this.toJoinVendorList = res.data.data;
            this.joinVendorList = res.data.data.map(item => item.vendorId);
          } else {
            this.toJoinVendorList = [];
            this.joinVendorList = [];
          }
        });
        this.isJoinByParmas = true;
        this.isBooking = false;
        this.bookingStartDays = null;
        this.bookingEndDays = null;
        this.dialogVisible2 = true;
        this.joinLoading = false;
      } else {
        this.$message.warning(res.data.message || '系统异常');
        this.joinLoading = false;
      }
    },
    async quitByParmas() {
      this.quitLoading = true;
      const res = await getCounterSpuList({
        ...this.getQueryParams(),
        pageSize: 1,
      });
      if (res.data && res.data.data) {
        if (!res.data.data.list || res.data.data.list.length === 0) {
          this.$message('当前没有商品可以退出');
          this.quitLoading = false;
          return;
        }
        this.quitLoading = false;
        this.$confirm('确认提交批量退出任务？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCounterSpuByParam(this.getQueryParams()).then((res) => {
            if (res.data && res.data.success) {
              this.$message.success('批量退出任务已提交，请在任务管理中查看任务完成情况');
              this.getTableData();
            } else {
              this.$message.warning(res.data.message || '系统异常');
            }
            this.quitLoading = false;
          })
        }).catch(() => {});
      } else {
        this.$message.warning(res.data.message || '系统异常');
        this.quitLoading = false;
      }
    },
    onClickSelectAll() {
      this.joinVendorList = this.toJoinVendorList.map(item => item.vendorId);
    },
    onClickClear() {
      this.joinVendorList = [];
    },
    submitForm() {
      if (this.isBooking && (!this.bookingEndDays || !this.bookingStartDays)) {
        this.$message('请输入预定天数');
        return;
      }
      if (this.joinVendorList.length === 0) {
        this.$message('请选择至少一家买手店');
        return;
      }
      if (this.isJoinByParmas) {
        this.confirmAndSubmit('部分SPU因没有品牌尺码可能无法加入成功，是否继续提交？');
      } else {
        addCounterSpuBySpuIds({
          spuIds: this.multipleSelection.map(item => item.spuId),
          addVendorIds: this.joinVendorList,
          brandIds: [this.multipleSelection[0].brandId],
        }).then(res => {
          if (res.data) {
            if (res.data.success) {
              this.dialogVisible2 = false;
              this.$message.success('批量加入任务已提交，请在任务管理中查看任务完成情况')
              this.getTableData();
            } else if (res.data.code === '999') {
              this.confirmAndSubmit(res.data.message);
            } else {
              this.$message.warning(res.data.message || '系统异常');
            }
          } else {
            this.$message.error('系统异常');
          }
        })
      }
    },
    confirmAndSubmit(message) {
      this.$confirm(message, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let request = Promise.reject();
        if (this.isJoinByParmas) {
          request = confirmAddCounterSpuByParam({
            ...this.getQueryParams(),
            brandIds: [this.joinByParmasBrandId],
            addVendorIds: this.joinVendorList,
            isBooking: this.isBooking,
            bookingStartDays: this.bookingStartDays,
            bookingEndDays: this.bookingEndDays,
          });
        } else {
          request = confirmAddCounterSpuBySpuIds({
            spuIds: this.multipleSelection.map(item => item.spuId),
            addVendorIds: this.joinVendorList,
            brandIds: [this.multipleSelection[0].brandId],
            isBooking: this.isBooking,
            bookingStartDays: this.bookingStartDays,
            bookingEndDays: this.bookingEndDays,
          });
        }
        request.then((res) => {
          if (res.data && res.data.success) {
            this.dialogVisible2 = false;
            this.getTableData();
            this.$message.success('批量加入任务已提交，请在任务管理中查看任务完成情况');
          } else {
            this.$message.warning(res.data.message || '系统异常');
          }
        })
      }).catch(() => {});
    },
    inputNum(val, field) {
      val = val.replace(/[^\d]/g, '');
      this[field] = val;
    },
    changeBookingDays() {
      if (this.bookingStartDays && this.bookingEndDays) {
        if (this.bookingStartDays*1 > this.bookingEndDays * 1) {
          const num = this.bookingStartDays;
          this.bookingStartDays = this.bookingEndDays;
          this.bookingEndDays = num;
        }
      }
      if (Number(this.bookingStartDays) < 1) {
        this.bookingStartDays = 1;
      } else if (Number(this.bookingStartDays) > 100) {
        this.bookingStartDays = 100;
      }
      if (Number(this.bookingEndDays) > 100) {
        this.bookingEndDays = 100;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.ml10 {
  margin-left: 10px;
}
</style>
